const info = {
  ZH: { //中文翻译
    maintitle: " \u4e2d\u56fd\u6c7d\u8f66\u6750\u6599\u6570\u636e\u7cfb\u7edf",
    textlenght: "   \u8f93\u5165\u6587\u672c\u592a\u957f!",
    status: " \u5df2\u63a5\u6536\u7684\u6750\u6599\u6570\u636e\u8868",
    title: " \u5df2\u63a5\u6536\u7684\u6750\u6599\u6570\u636e\u8868\u72b6\u6001",
    refused: " >>\u62d2\u7edd",
    mtable: " \u6750\u6599\u6570\u636e\u8868:",
    name: " \u540d\u79f0:",
    version: " ID/\u7248\u672c:",
    resend: " \u63a5\u6536\u65f6\u95f4",
    org: " \u51fa\u81ea\u4f01\u4e1a:",
    in: " \u5728:",
    stautsDis: " \u72b6\u6001 \u63cf\u8ff0:",
    nsen: "  \u8fd8\u672a\u88ab\u6d4f\u89c8",
    acpt: "  \u5df2\u88ab\u6279\u51c6\u7684",
    modi: "  \u5df2\u88ab\u4fee\u6539\u7684",
    prec: "  \u6b63\u88ab\u63a5\u6536\u8005\u5904\u7406",
    seen: "  \u5df2\u88ab\u6d4f\u89c8\u7684",
    recd: "  \u5df2\u88ab\u62d2\u7edd\u7684",
    cbs: "  \u88ab\u53d1\u9001\u4eba\u53d6\u6d88",
    refusedreason: " \u62d2\u7edd\u539f\u56e0:",
    view: " \u67e5\u770b",
    send: " \u786e\u5b9a",
    cancel: " \u53d6\u6d88",
    refusedCheckLable1: " 法规不符合",
    refusedCheckLable2:"填写规则不符合",
  },
  EN: { //英文翻译
    maintitle: "	China Automotive Material Data System (CAMDS)",
    textlenght: "	The text you entered is too long!",
    status: "	Received MDSs",
    title: "	  Status received MDS",
    refused: "	 >>Reject",
    mtable: "	MDS",
    name: "	Name",
    version: "ID/Version\uFF1A",
    resend: "	Reception time",
    org: "	Original enterprise",
    in: "	In:",
    stautsDis: "	Status description:",
    nsen: "	not yet browsed",
    acpt: "	accepted",
    modi: "	modified",
    prec: "	Being processed by recipient",
    seen: "	browsed",
    recd: "	Rejected",
    cbs: "canceled by sender",
    refusedreason: "	Reason for rejection:",
    view: "	view",
    send: "	OK",
    cancel: "	Cancel",
    refusedCheckLable1: "Regulation non-compliance",
    refusedCheckLable2:"Non-compliance with filling rules",
  },
}
export default info //需要暴露出去
